import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 3 }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip me-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes)
  }, [
    (_ctx.isImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.fileUrl,
            alt: "Image",
            class: "img-thumbnail"
          }, null, 8, _hoisted_2)
        ]))
      : (_ctx.isVideo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("video", {
              controls: "",
              src: _ctx.fileUrl,
              class: _normalizeClass([_ctx.classes, 'img-thumbnail'])
            }, null, 10, _hoisted_4)
          ]))
        : (_ctx.isAudio)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("audio", {
                controls: "",
                src: _ctx.fileUrl,
                class: _normalizeClass([_ctx.classes, 'img-thumbnail'])
              }, null, 10, _hoisted_6)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("a", {
                href: _ctx.fileUrl,
                class: "btn btn-sm btn-outline-primary text-nowrap",
                target: "_blank"
              }, [
                _hoisted_9,
                _createTextVNode(_toDisplayString(_ctx.translate("View the file")), 1)
              ], 8, _hoisted_8)
            ]))
  ], 2))
}